var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.306,
    height: 13.522,
    viewBox: "0 0 12.306 13.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6808",
    d: "M2070.338 869.8a3.4 3.4 0 1 0-3.4-3.4 3.4 3.4 0 0 0 3.4 3.4zm0-5.387a1.986 1.986 0 1 1-1.986 1.986 1.988 1.988 0 0 1 1.986-1.986z",
    className: "cls-1",
    transform: "translate(-2064.184 -863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6809",
    d: "M2063.575 880.031a.706.706 0 0 0 .7-.615 4.782 4.782 0 0 1 9.485 0 .707.707 0 0 0 .7.615.708.708 0 0 0 .7-.8 6.2 6.2 0 0 0-12.295 0 .708.708 0 0 0 .7.795z",
    className: "cls-1",
    transform: "translate(-2062.865 -866.509)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.95a46214.svg";
export { ForwardRef as ReactComponent };